export default () => {
	const { location: { href } } = window;
	let env = 'local';

	if (href.includes('-dev'))
		env = 'dev';
	else if (href.includes('dev.'))
		env = 'dev';
	else if (href.includes('-stg'))
		env = 'stg';
	else if (href.includes('stg.'))
		env = 'stg';
	else if (href.includes('-sandbox'))
		env = 'sandbox';
	else if (href.includes('sandbox.'))
		env = 'sandbox';
	else if (href.indexOf('posillicomaterials.com') !== -1)
		env = 'prod';
	else if (href.indexOf('posillico-materials.netlify') !== -1)
		env = 'prod';

	return env;
};
